import { getLocalTime } from '../utils/getLocalTime';
import type { ScheduleType } from './models';

export const getLocalSchedule = (
  schedule: string[] | undefined,
  t: (...args: any) => string,
  timeFormat: string,
): ScheduleType[] => {
  if (!schedule || !schedule.length || !schedule[0]) {
    return [];
  }

  return schedule.map((dayTimeRange: string) => {
    const dayTimeRangeInfo = dayTimeRange.split('-').map((item: string) => item.trim());

    return {
      startDay: t(`AbbreviatedWeekday.${dayTimeRangeInfo[0]}`),
      endDay: t(`AbbreviatedWeekday.${dayTimeRangeInfo[1]}`),
      startTime: getLocalTime(dayTimeRangeInfo[2], timeFormat),
      endTime: getLocalTime(dayTimeRangeInfo[3], timeFormat),
    };
  });
};
